import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import instance from '../../services/auth.service';
import { API_CONFIG } from '../../config/api.config';

// Async thunks
export const fetchCards = createAsyncThunk(
  'cards/fetchAll',
  async ({ page = 1, limit = 20, search = "" } = {}, { rejectWithValue }) => {
    try {
      const response = await instance.get(
        API_CONFIG.ENDPOINTS.CARDS.GET_ALL(page, limit, search)
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

export const addCard = createAsyncThunk(
  'cards/add',
  async (cardData, { rejectWithValue }) => {
    try {
      const response = await instance.post(API_CONFIG.ENDPOINTS.CARDS.ADD, cardData);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

export const updateCard = createAsyncThunk(
  'cards/update',
  async ({ id, cardData }, { rejectWithValue }) => {
    try {
      const response = await instance.put(
        API_CONFIG.ENDPOINTS.CARDS.UPDATE(id),
        cardData
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

export const deleteCard = createAsyncThunk(
  'cards/delete',
  async (id, { rejectWithValue }) => {
    try {
      await instance.delete(API_CONFIG.ENDPOINTS.CARDS.DELETE(id));
      return id;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

const cardSlice = createSlice({
  name: 'cards',
  initialState: {
    items: [],
    pagination: {
      currentPage: 1,
      pageSize: 20,
      totalItems: 0,
      totalPages: 1,
    },
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      // Fetch cards
      .addCase(fetchCards.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchCards.fulfilled, (state, action) => {
        state.loading = false;
        state.items = action.payload.aircrafts;
        state.pagination = action.payload.pagination;
        state.error = null;
      })
      .addCase(fetchCards.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      // Add card
      .addCase(addCard.fulfilled, (state, action) => {
        // state.items.push(action.payload);
      })
      // Update card
      .addCase(updateCard.fulfilled, (state, action) => {
        // const index = state.items.findIndex(card => card.id === action.payload.id);
        // if (index !== -1) {
        //   state.items[index] = action.payload;
        // }
      })
      // Delete card
      .addCase(deleteCard.fulfilled, (state, action) => {
        // state.items = state.items.filter(card => card.id !== action.payload);
      });
  },
});

export default cardSlice.reducer;
